export default {
  unavailable: {
    title: 'Las facturas de clientes no están disponibles',
    description:
      'Los clientes que realizan pedidos en tus restaurantes no pueden solicitar una factura, por lo que no hay nada que configurar aquí. Los recibos de pedidos y las facturas que tu proveedor te emite no se ven afectados.',
  },
};
